const { boxShadow } = require('tailwindcss/defaultTheme')

module.exports = {
  ...boxShadow,
  default: '0 4px 8px 0 rgba(0,0,0,0.3)',
}
